import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TopicIcon(props: IconProps) {
    return <Icon {...props} iconKey={"topic"}/>
}
